var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.educatorRoles.includes(_vm.appMode) && _vm.requestId)?_c('EducatorRequestDetails',{ref:"educatorRequestDetails"}):(_vm.partnerRoles.includes(_vm.appMode) && _vm.requestId)?_c('EmployeeRequestDetails',{ref:"partnerRequestDetails"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }